// React
import React, { Component } from "react";
// Material
import { FormControl, TextField, InputLabel } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
// Styles
import { withStyles } from "@material-ui/core/styles";
import "../../styles.scss";

const useStyles = {
  formControl: {
    maxWidth: (props) => (props.maxWidth ? props.maxWidth : "100%"),
  },
  inputLabel: {
    color: "red",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100%",
    display: "ruby",
    textAlign: "left",
    paddingBottom: "5px",
  },
  root: {
    backgroundColor: "yellow",
  },
  clearIndicator: {
    display: "none",
    backgroundColor: "gray",
    "& span": {
      "& svg": {
        backgroundColor: "red",
      },
    },
  },
  popupIndicatorOpen: {
    paddingRight: "0px",
    paddingLeft: "10px",
  },
  popupIndicator: {
    paddingRight: "10px",
    "& span": {
      "& svg": {
        "& path": {
          d: "path('M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z')",
        },
      },
    },
  },
  error: {
    border: "1px solid red",
    color: "red",
    borderRadius: "5px",
  },
  errorText: {
    color: "red",
  },
};

class SelectAutocomplete extends Component {
  handleOnSelect = (e, new_value) => {
    e.preventDefault();
    e.stopPropagation();
    const { onSelect, type, iteration, value_type } = this.props;

    onSelect(value_type ? new_value[value_type] : new_value, type, iteration);
  };

  render() {
    const {
      items,
      value,
      placeholder,
      className,
      searchOption,
      classes,
      label,
      t,
      error,
      helperText,
    } = this.props;
    return (
      <FormControl
        className={`platform_select_simple ${className ?? "select_primary"} ${
          classes.formControl
        } ${error ? `${classes.error} ${classes.errorText}` : ""}`}
      >
        {label && (
          <InputLabel className={`${classes.inputLabel}`}>{label}</InputLabel>
        )}
        <Autocomplete
          options={items}
          getOptionLabel={(option) =>
            option[searchOption] ? option[searchOption] : ""
          }
          id="controlled-demo"
          value={value}
          onChange={(e, newValue) => {
            this.handleOnSelect(e, newValue);
          }}
          className={error ? classes.errorText : ""}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholder}
              variant="standard"
              error={error}
              helperText={error ? helperText : ""}
              inputProps={{
                ...params.inputProps,
                style: {
                  ...params.inputProps.style,
                  color: error ? "red" : "",
                },
              }}
            />
          )}
          classes={{
            clearIndicatorDirty: classes.clearIndicator,
            popupIndicator: classes.popupIndicator,
          }}
          noOptionsText={t("commons:input.select.autocomplete.no_options")}
        />
      </FormControl>
    );
  }
}

export default withStyles(useStyles)(SelectAutocomplete);
